<div *ngIf="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">
    <div class="text">
        <i class="hx-icon hx-icon-warning"></i>
        {{message.text}}
    </div>
</div>
